/**
 * Utility functions for page config related functionality in search
 */
import SearchExperiments from 'bundles/epic/clients/search';

/**
 * List of queries that should use the page config system for free content experience
 */
export const FREE_QUERIES = [
  'free',
  'free courses with certificate',
  'free courses',
  'free certificate courses',
  'free course with certificate',
  'free  courses with certificate',
  'free course',
  'free/',
  'free certificate',
  'free guided projects',
  'free certificate course',
  'free degree',
  'free online courses',
  'free certification',
  'free certificat courses',
  'free cources',
  'free courses with free certificate',
  'free courses with certificates',
  'free  courses',
  'free certification courses',
  'free certifications',
  '1 hour free',
  'free course less than 2 hours',
  'free projects',
  '/free',
  'free with certificate',
  'free online course',
  'free certification course',
  'free corse',
  'free online courses with certificate',
  `gratis`,
  `cursos gratis`,
];

/**
 * Determines if a search query should use the page config system for free content
 */
export const isFreeQuery = (query?: string | string[]): boolean => {
  if (!query) return false;
  let normalizedQuery = query;
  if (Array.isArray(normalizedQuery)) {
    normalizedQuery = normalizedQuery.filter(Boolean)[0];
  }
  if (!normalizedQuery) return false;
  normalizedQuery = normalizedQuery.trim().toLowerCase();
  return FREE_QUERIES.includes(normalizedQuery);
};

export const isInFreeQueryExperimentImpression = (): boolean => {
  return SearchExperiments.get('freeQuery') === true;
};

export const isInFreeQueryExperiment = (): boolean => {
  return SearchExperiments.preview('freeQuery') === true;
};

/**
 * Determines if a search should use the page config system
 * based on query content and experiment status, impress only if they are part of FREE_QUERIES
 */
export const shouldShowFreeQueryPageConfig = (query?: string): boolean => {
  return isFreeQuery(query) && isInFreeQueryExperimentImpression();
};

export const shouldShowFreeQueryPageConfigPreview = (query?: string): boolean => {
  return isFreeQuery(query) && isInFreeQueryExperiment();
};

type FreeQueryCounts = {
  freeCount: number;
  freeTrialCount: number;
};

export const freeQueriesValuePropCounts = (): FreeQueryCounts => {
  return { freeCount: 1112, freeTrialCount: 7815 };
};
